<template>
	<div id="modal-validation-reminder">
		<div class="rp-overlay"></div>
		<div class="rp-modal" style="width: 470px;">
			<div class="rp-modal-header">
				<h3 class="rp-modal-title">{{ $t('Validate before training') }}</h3>
				<button class="rp-btn-dismiss" @click="$emit('closeModal')">
					<XIcon class="w-5 h-5" />
				</button>
			</div>
			<div class="bg-white p-5">
				<div>
					<div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
						<div class="flex items-start">
							<AlertTriangleIcon class="w-5 h-5 text-yellow-600 mt-0.5 mr-3 flex-shrink-0" />
							<div>
								<h3 class="text-sm font-medium text-yellow-800 mb-1">{{ $t('Validation recommended') }}</h3>
								<p class="text-sm text-yellow-700">
									{{ $t('It is highly recommended to validate your annotations before starting the training to ensure optimal model performance.') }}
								</p>
							</div>
						</div>
					</div>
				</div>

				<div v-if="dataset && dataset.tagStats" class="mb-4">
					<h3 class="text-sm font-medium text-gray-700 mb-3">{{ $t('Dataset overview') }}</h3>
					<div class="bg-gray-50 rounded-lg p-4">
						<div class="space-y-2">
							<div v-for="(count, tagId) in dataset.tagStats.tags" :key="tagId" class="flex items-center justify-between">
								<div class="flex items-center">
									<div 
										class="w-3 h-3 rounded-full mr-2" 
										:style="{ backgroundColor: dataset.tags[tagId]?.color || '#gray-400' }">
									</div>
									<span class="text-xs text-gray-700">{{ dataset.tags[tagId]?.name || 'Unknown' }}</span>
								</div>
								<span class="text-xs font-medium text-gray-600">{{ count }}</span>
							</div>
						</div>
					</div>
				</div>

				<div class="rp-modal-body-buttons gap-3 mt-4">
					<button class="rp-btn-secondary" @click="$emit('continueToTrain')">
						{{ $t('Start training') }}
					</button>
					<button class="rp-btn-primary" @click="$emit('validate')">
						{{ $t('Validate') }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	dataset: {
		type: Object,
		required: true
	}
});

const $emit = defineEmits(['closeModal', 'validate', 'continueToTrain']);
</script> 